module.exports = __webpack_public_path__ + "static/img/hr11.e096eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr11.jpg
// module id = PURI
// module chunks = 0